import { ConversationStatus, EntityType, inIframe, isNullOrEmpty, MAX_RECORD, SELLER_SITE_PATH, WEBSITE_PATH, windowPostMessage } from "../common/common";
import { Box, Button, CircularProgress } from "@mui/material";
import { FollowersNullSet } from "../components/nullSets/chatNullset";
import { useContext, useEffect, useRef, useState } from "react";
import { resource } from "../common/resource";
import { StoreDetailsContext } from "../contexts/entityDetailsContext";
import { ChatHistory } from "../models/messaging";
import { deleteAPIAsync, getAPI } from "../api/apiCalls";
import InboxSkeleton from "../components/skeletonLoaders/inboxSkeleton";
import Provider from "../api/provider";
import StoreListCards, { SetStoreData } from "../components/storeCardList";
import { isBrowser, isMobileOnly, isTablet } from "react-device-detect";
import { useSearchParams } from "react-router-dom";

const StoreRequestMessage = () => {
  const { storeDetails, setStoreDetails } = useContext<any>(StoreDetailsContext);
  const [chatHistory, setChatHistory] = useState<ChatHistory[]>([]);
  const [pageNo, setPageNo] = useState<number>(0);
  const [isAjax, setIsAjax] = useState<boolean>(true);
  const [loader, setLoader] = useState<boolean>(false);
  const [nullSet, setNullSet] = useState<boolean>(false);
  const [loaderPage, setLoaderPage] = useState<boolean>(true);
  const [searchParam] = useSearchParams();
  const containerRef: any = useRef();
  const storecodenum: any = useRef<string>();
  const chatHistoryRef: any = useRef();
  //#region useeffect
  useEffect(() => {
    if (!inIframe()) {
      window.location.href = WEBSITE_PATH;
      return;
    }
    storecodenum.current = encodeURIComponent(searchParam.get("storeId"));

    window.addEventListener("resize", handleWindowResize);
    window.addEventListener("message", handleWindowMessageReceived);

    return () => {
      window.removeEventListener("message", handleWindowMessageReceived);
      window.removeEventListener("resize", handleWindowResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    chatHistoryRef.current = chatHistory;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chatHistory]);

  useEffect(() => {
    storeDetails && getStoreInboxConversation(storeDetails.scnum, pageNo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeDetails]);

  useEffect(() => {
    pageNo !== 0 && storeDetails && getStoreInboxConversation(storeDetails.scnum, pageNo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNo]);

  useEffect(() => {
    if (isNullOrEmpty(storeDetails)) {
      windowPostMessage({ type: "getstoredetails" }, WEBSITE_PATH);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeDetails]);

  //#endregion

  //#region Api calls
  const getStoreInboxConversation = (storecodenum: string, pageNoVal: number) => {
    getAPI(
      Provider.URLS.BASE_URL,
      Provider.API_URLS.InboxHistory,
      {
        ucnum: storecodenum,
        pageSize: MAX_RECORD,
        pageNo: pageNoVal,
        entityType: EntityType.STORE,
        status: ConversationStatus.PENDING,
      },
      (response: any) => {
        let data = response.data;
        if (data) {
          data = response.data.conversationsResponse;
          if (chatHistory.length > 0) {
            setChatHistory([...chatHistory, ...data]);
          } else setChatHistory(data);

          setIsAjax(!(data.length < MAX_RECORD));
        } else {
          setIsAjax(false);
          pageNo === 0 && setNullSet(true);
        }
        setLoader(false);
        setLoaderPage(false);
      },
      (e: any) => {
        setLoaderPage(false);
        setLoader(false);
        setIsAjax(false);
        pageNo === 0 && setNullSet(true);
        windowPostMessage({ type: "snackMsg", snackMsg: resource.error }, SELLER_SITE_PATH);
      }
    );
  };

  const onDeleteAll = () => {
    deleteAPIAsync(
      Provider.URLS.BASE_URL,
      Provider.API_URLS.DeleteAllPendingRequest,
      { scnum: storeDetails.scnum },
      () => {
        setNullSet(true);
        windowPostMessage({ type: "closeAllChats" }, SELLER_SITE_PATH);
      },
      () => {
        windowPostMessage({ type: "snackMsg", snackMsg: resource.error }, WEBSITE_PATH);
      }
    );
  };
  //#endregion

  //#region Function calls
  const handleWindowMessageReceived = (event: any) => {
    if (event.origin && event.origin.includes(SELLER_SITE_PATH.slice(0, -1))) {
      const data = event.data;
      if (data.storeAction && data.storeAction === "delete") {
        onDeleteAll();
      } else if (data.type === "storedetails") {
        SetStoreData(storecodenum.current, data.storeDetails, searchParam.get("sessionId"), setStoreDetails);
      } else if (data.type === "updateConnectivityStatus") {
        updateConnectivityStatus(data.entityCodeNum, data.action, data.status);
      } else if (data.type === "typing") {
        updateTypingStatus(data.entityCodeNum, data.action);
      }
    }
  };

  const updateConnectivityStatus = (entityCodeNum: string, action: string, status: boolean) => {
    const currChatHistory: ChatHistory[] = [...chatHistoryRef.current];
    if (currChatHistory.length > 0) {
      const chatToUpdate: ChatHistory | undefined = currChatHistory.find((el) => el.user?.usercodenum === encodeURIComponent(entityCodeNum));
      if (chatToUpdate && chatToUpdate.user) {
        chatToUpdate.user.connectivityStatus = action === "mute" ? status : true;
        chatToUpdate.user.connectivityTstamp = action === "leave" ? new Date().getTime() : null;
      }
    }
    setChatHistory(currChatHistory);
  };

  const updateTypingStatus = (entityCodeNum: string, action: boolean) => {
    const currChatHistory: ChatHistory[] = [...chatHistoryRef.current];
    if (currChatHistory.length > 0) {
      const chatToUpdate: ChatHistory | undefined = currChatHistory.find((el) => el.user?.usercodenum === encodeURIComponent(entityCodeNum));
      if (chatToUpdate) {
        chatToUpdate.isTyping = action;
      }
    }
    setChatHistory(currChatHistory);
  };

  const handleWindowResize = () => {
    if (containerRef && containerRef.current) {
      switch (true) {
        case isBrowser:
          containerRef.current.style.height = window.innerHeight - 126 + "px";
          break;
        case isTablet:
          containerRef.current.style.height = window.innerHeight - 170 + "px";
        case isMobileOnly:
          containerRef.current.style.height = window.innerHeight - 126 + "px";
      }
    }
  };

  const onScrollEvent = (e: any) => {
    const $eTarget = e.currentTarget;
    if (!isAjax || !($eTarget.scrollHeight - $eTarget.scrollTop - 10 <= $eTarget.clientHeight)) {
      return;
    }
    setLoader(true);
    setIsAjax(false);
    setPageNo(pageNo + MAX_RECORD);
  };

  const onDeleteBtnClick = () => {
    windowPostMessage({ type: "deleteAllPendingRequest" }, SELLER_SITE_PATH);
  };
  //#endregion

  return (
    <Box>
      {nullSet ? (
        <Box className={`inboxContentContainerEmpty ${isMobileOnly ? "mar-t-16" : "mar-t-24"}`}>
          <FollowersNullSet header="No message requests" body={`${resource.quotationRequest}`} />
        </Box>
      ) : loaderPage ? (
        <InboxSkeleton noTop={true} />
      ) : (
        <Box className="flex-column align-items-center">
          <Box ref={containerRef} className="w-per-100 flex-column" sx={{ height: window.innerHeight - (isBrowser ? 126 : isTablet ? 170 : 126) + "px" }}>
            <Box className="flex-column flex-grow pad-l-r-gutter" onScroll={onScrollEvent}>
              {chatHistory.length > 0 && <StoreListCards data={chatHistory} type="messageRequest" />}
              {loader && (
                <Box className="flex-center ht-72" sx={{ m: 2 }}>
                  <CircularProgress className="box-24" />
                </Box>
              )}
            </Box>
            <Box sx={{ padding: "4px 16px 16px" }}>
              <Button variant="contained" className="w-per-100 MuiButton-contained-tonal" onClick={onDeleteBtnClick}>
                Delete all
              </Button>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default StoreRequestMessage;
